module.exports = __webpack_public_path__ + "static/media/sun-country-favicon.47f810b1.ico";